import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface SectionHeaderProps {
  /** Section title to display (e.g., "Upcoming", "Past Periods") */
  title: string;
  /** Count of items to display in the Chip */
  count: number;
  /** Optional color for the Chip (default: 'primary') */
  color?: 'primary' | 'error';
}

/**
 * SectionHeader
 *
 * A reusable header for course period sections that displays
 * the title and a small Chip with the count.
 *
 * Example usage:
 * <SectionHeader title="Past Periods" count={3} color="primary" />
 */
export function SectionHeader({ title, count, color = 'primary' }: SectionHeaderProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography variant="subtitle1" fontWeight={700}>
        {title}
      </Typography>
      <Chip label={count} size="small" color={color} />
    </Stack>
  );
}

export default SectionHeader;
